import range from 'lodash/range';

const parseTicketType = (ticketType) => {
  const result = {
    ticket_type_id: ticketType.ticket_type_id,
    ticket_type_name: ticketType.name,
    ticket_type_price: ticketType.price,
    quantity: ticketType.quantity,
  };

  if (ticketType.seatsIoInfo) {
    if (!ticketType.seatsIoInfo.parent) {
      result.section = ticketType.seatsIoInfo.displayedLabel;
      result.seats = range(ticketType.quantity).map(() => ({
        section: ticketType.seatsIoInfo.own,
      }));
    } else {
      result.section = ticketType.seatsIoInfo.section;
      result.seats = [
        {
          section: ticketType.seatsIoInfo.section,
          row: ticketType.seatsIoInfo.parent,
          seat: parseInt(ticketType.seatsIoInfo.own, 10),
        },
      ];
    }
  } else if (ticketType.category) {
    result.section = ticketType.category.name;
    result.seats = range(ticketType.quantity).map(() => ({
      section: ticketType.category.name,
    }));
  }

  return result;
};

const mergeTicketType = (prev, current) => {
  if (prev) {
    const result = prev;
    result.quantity += current.quantity;
    if (result.seats) {
      result.seats = [...result.seats, ...current.seats];
    }
    return result;
  }
  return current;
};

const getTicketsSelectedMergeByTicketType = (ticketsSelected) => {
  const ticketTypesSelected = {};
  ticketsSelected.map((ticketType) => {
    ticketTypesSelected[ticketType.ticket_type_id] = mergeTicketType(
      ticketTypesSelected[ticketType.ticket_type_id],
      parseTicketType(ticketType),
    );
  });

  return ticketTypesSelected;
};

export { getTicketsSelectedMergeByTicketType };
